import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuthStore } from '../store/authStore';
import Brand from '../components/Brand';
import { Check, ArrowRight } from 'lucide-react';

const AVATARS = [
  { id: 'wise', label: 'The Wise', emoji: '🧙' },
  { id: 'seeker', label: 'The Seeker', emoji: '🌄' },
  { id: 'healer', label: 'The Healer', emoji: '🌿' },
  { id: 'dreamer', label: 'The Dreamer', emoji: '🌙' },
  { id: 'builder', label: 'The Builder', emoji: '⛒' },
  { id: 'guardian', label: 'The Guardian', emoji: '🛡️' },
];

export default function OnboardingPage() {
  const { user, updateAvatar, refreshMe } = useAuthStore();
  const [selected, setSelected] = useState(user?.selected_avatar || null);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const finish = async () => {
    if (!selected) return;
    setBusy(true);
    try {
      await updateAvatar(selected);
      try { await api.post('/api/onboarding/complete'); } catch {}
      await refreshMe();
      nav('/dashboard');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ee-bg">
      <div className="p-6"><Brand /></div>
      <div className="max-w-2xl mx-auto px-6 py-12">
        <div className="text-center mb-10">
          <div className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Welcome</div>
          <h1 className="hero-title text-4xl text-white">Choose Your Avatar</h1>
          <p className="text-ee-text2 mt-2">Pick an inner archetype to guide your journey. You can change it later.</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {AVATARS.map((a) => (
            <button data-testid={`avatar-${a.id}`} key={a.id} onClick={() => setSelected(a.id)} className={`relative ee-card p-5 text-center transition-all ${selected === a.id ? 'border-gold ring-1 ring-gold' : 'hover:border-gold/30'}`}>
              <div className="text-4xl mb-2">{a.emoji}</div>
              <div className="text-sm text-white">{a.label}</div>
              {selected === a.id && <div className="absolute top-2 right-2 w-6 h-6 rounded-full gold-bg flex items-center justify-center text-black"><Check size={14} /></div>}
            </button>
          ))}
        </div>
        <button data-testid="onboarding-finish" onClick={finish} disabled={!selected || busy} className="mt-8 w-full inline-flex items-center justify-center gap-2 py-3.5 rounded-md gold-grad text-black font-semibold disabled:opacity-40">
          {busy ? 'Saving…' : <>Continue <ArrowRight size={16} /></>}
        </button>
      </div>
    </div>
  );
}
